/* =====================================================================
   JOIEX v6 motion (deferred, every page)
   - Home page section stepping: on desktop a wheel notch, swipe or arrow /
     Page / Space key moves exactly one section (tall sections get extra stops);
     touch screens scroll freely (the flight still follows the scroll). Dragging the scrollbar stays free.
   - Section dots on the right (desktop home).
   - Hero product flight: the floating hero product travels into the landing
     stage of the next image-with-text section while the page scrolls.
   - Reveal on enter for headings, tiles and cards (all pages).
   Settings come from <body data-jx-snap|dots|flight|reveal="true|false">; revealed
   elements carry data-jxr (a different name, so the body flag never matches).
   Everything is off in the theme editor (data-jx-design="true") and for
   visitors who ask for reduced motion.
   Debug handle: window.JXMotion.
   ===================================================================== */
(function () {
  'use strict';
  if (window.JXMotion) return;

  var d = document;
  var de = d.documentElement;
  var body = d.body;
  if (!body) return;
  /* the hero's saved "Pause motion" choice stills looping animations on every page */
  try { if (window.localStorage.getItem('joiex_motion') === 'paused') de.classList.add('jx-motion-paused'); } catch (e) { /* storage blocked */ }

  var ds = body.dataset || {};
  var STR = window.JX_STR || {};
  var on = function (k) { return ds[k] === 'true'; };
  var mm = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var listenMq = function (m, fn) {
    if (m.addEventListener) m.addEventListener('change', fn);
    else if (m.addListener) m.addListener(fn);
  };
  var mqReduce = mm('(prefers-reduced-motion: reduce)');
  var mqFine = mm('(hover: hover) and (pointer: fine)');
  var reduced = function () { return !!mqReduce.matches; };
  var design = on('jxDesign');
  var isHome = body.classList.contains('template-index');

  var clamp = function (v, a, b) { return v < a ? a : (v > b ? b : v); };
  var now = function () { return window.performance ? performance.now() : Date.now(); };
  var scrollY = function () { return window.pageYOffset || de.scrollTop || 0; };
  var maxScroll = function () { return Math.max(0, de.scrollHeight - window.innerHeight); };
  var docTop = function (el) { return el.getBoundingClientRect().top + scrollY(); };
  /* rAF, or run now when the tab is hidden (rAF is frozen there) */
  var frame = function (fn) {
    if (d.hidden || !window.requestAnimationFrame) { fn(now()); return 0; }
    return window.requestAnimationFrame(fn);
  };

  var MAIN = d.getElementById('MainContent');
  var HEADER = d.getElementById('shopify-section-header');
  var ANNOUNCE = d.getElementById('shopify-section-announcement-bar');
  var FOOTER = d.getElementById('shopify-section-footer');

  function headerH() {
    if (!HEADER) return 0;
    var p = getComputedStyle(HEADER).position;
    return (p === 'sticky' || p === 'fixed') ? HEADER.offsetHeight : 0;
  }

  /* mobile menu, promo modal or any open dialog: leave scrolling alone */
  function overlayOpen() {
    if (de.classList.contains('jx-drawer-open') || body.style.overflow === 'hidden') return true;
    var list = d.querySelectorAll('.backdrop, .mobile-nav, [aria-modal="true"]');
    for (var i = 0; i < list.length; i++) {
      var cs = getComputedStyle(list[i]);
      if (cs.display !== 'none' && cs.visibility === 'visible' && parseFloat(cs.opacity) > 0.05 &&
          list[i].getBoundingClientRect().height > 0) return true;
    }
    return false;
  }

  /* is the wheel over an inner scroller that can still move that way? */
  function canScrollInside(el, dy) {
    for (; el && el.nodeType === 1 && el !== body && el !== de; el = el.parentElement) {
      if (el.scrollHeight > el.clientHeight + 1) {
        var oy = getComputedStyle(el).overflowY;
        if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') {
          if (dy > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 1 : el.scrollTop > 0) return true;
        }
      }
    }
    return false;
  }

  function sectionsOf() {
    if (!MAIN) return [];
    return [].filter.call(MAIN.children, function (s) {
      return s.classList.contains('shopify-section') && s.offsetHeight > 0;
    });
  }
  /* a thin band (trust bar) travels with the section after it */
  function isShort(s, avail) { return s.offsetHeight < avail * 0.3; }

  function textOf(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function labelOf(els, i) {
    for (var k = 0; k < els.length; k++) {
      var t = textOf(els[k].querySelector('.eyebrow')) || textOf(els[k].querySelector('h1, h2'));
      if (t) return t.length > 42 ? t.slice(0, 40) + '…' : t;
    }
    return (STR.section || 'Section') + ' ' + (i + 1);
  }

  function groupsOf() {
    var hh = headerH();
    var avail = window.innerHeight - hh;
    var groups = [];
    var lead = false;
    sectionsOf().forEach(function (s) {
      if (lead && groups.length) groups[groups.length - 1].els.push(s);
      else groups.push({ els: [s] });
      lead = isShort(s, avail);
    });
    groups.forEach(function (g, i) {
      var first = g.els[0];
      var last = g.els[g.els.length - 1];
      g.top = i === 0 ? 0 : docTop(first);
      g.bottom = docTop(last) + last.offsetHeight;
      g.y = i === 0 ? 0 : Math.max(0, g.top - hh);
      g.label = labelOf(g.els, i);
    });
    return groups;
  }

  /* scroll stops: each group top (just under the sticky header), extra stops
     inside groups taller than the screen, and the page end (footer) */
  function pointsOf(groups) {
    var vh = window.innerHeight;
    var hh = headerH();
    var avail = vh - hh;
    var ms = maxScroll();
    var pts = [];
    groups.forEach(function (g, i) {
      pts.push({ y: g.y, g: i, main: true });
      var visible = i === 0 ? vh : avail;
      var len = g.bottom - g.top;
      /* a sliver past the fold (bottom padding) is not worth a wheel step of its own */
      if (len > visible + Math.max(64, avail * 0.16)) {
        var end = g.bottom - vh;
        var step = avail * 0.8;
        for (var y = g.y + step; y < end - 80; y += step) pts.push({ y: y, g: i });
        pts.push({ y: end, g: i });
      }
    });
    if (FOOTER && groups.length) pts.push({ y: ms, g: groups.length - 1 });
    pts.forEach(function (p) { p.y = Math.round(clamp(p.y, 0, ms)); });
    pts.sort(function (a, b) { return a.y - b.y; });
    var out = [];
    pts.forEach(function (p) {
      var prev = out[out.length - 1];
      if (!prev || p.y - prev.y > 40) out.push(p);
      else if (p.main && !prev.main) out[out.length - 1] = p;
    });
    return out;
  }

  /* ------------------------------------------------------------------
     Section stepping
     ------------------------------------------------------------------ */
  var Snap = {
    mode: '',
    groups: [],
    pts: [],
    anim: null,
    armed: true,
    lastT: 0,
    lastAbs: 0,
    peak: 0,
    notchAbs: 0,
    accum: 0,
    animEnd: 0,
    lastWritten: -1,
    dots: null,
    dotBtns: [],

    wanted: function () {
      if (!isHome || !on('jxSnap') || design || reduced() || !MAIN) return '';
      if (!mqFine.matches) return 'touch';
      return (window.innerWidth >= 990 && window.innerHeight >= 560) ? 'js' : '';
    },

    apply: function () {
      var m = this.wanted();
      if (m !== this.mode) {
        this.teardown();
        this.mode = m;
        if (m === 'js') this.setupJs();
        else if (m === 'touch') this.setupTouch();
      }
      this.measure();
    },

    measure: function () {
      if (!this.mode) return;
      this.groups = groupsOf();
      if (this.mode === 'js') {
        this.pts = pointsOf(this.groups);
        this.syncDots();
      } else {
        this.flagTouch();
      }
    },

    setupTouch: function () {
      de.classList.add('jx-snap-touch');
    },

    flagTouch: function () {
      var hh = headerH();
      var avail = window.innerHeight - hh;
      var band = (ANNOUNCE && ANNOUNCE.offsetHeight > 0) ? ANNOUNCE : null;
      /* the product lands at the stage's own top when the band before it is too tall to
         travel with it (landscape phones): that band must not stop the page mid-flight */
      var stage = Flight.flyer ? Flight.iwt.closest('.shopify-section') : null;
      de.style.setProperty('--jx-header', hh + 'px');
      sectionsOf().forEach(function (s) {
        /* a thin band swallows the next stop only when both fit on one screen;
           otherwise the section keeps its own stop (tall ones scroll inside) */
        if ((band && band.offsetHeight + s.offsetHeight <= avail) ||
            (stage && s.nextElementSibling === stage && !isShort(s, avail))) s.setAttribute('data-jx-snap-skip', '');
        else s.removeAttribute('data-jx-snap-skip');
        band = isShort(s, avail) ? s : null;
      });
    },

    setupJs: function () {
      var s = this;
      de.classList.add('jx-snap');
      s.onWheel = function (e) { s.wheel(e); };
      s.onKey = function (e) { s.key(e); };
      /* a press on the scrollbar gutter hands control back to the visitor */
      s.onDown = function (e) { if (e.clientX >= de.clientWidth) s.cancel(); };
      s.onScroll = function () {
        if (s.anim && Math.abs(scrollY() - s.lastWritten) > 3) s.cancel();
        s.markSoon();
        s.wake();
      };
      s.onMove = function (e) { if (e.clientX >= de.clientWidth - 28) s.wake(); };
      window.addEventListener('wheel', s.onWheel, { passive: false });
      window.addEventListener('keydown', s.onKey);
      window.addEventListener('mousedown', s.onDown, true);
      window.addEventListener('scroll', s.onScroll, { passive: true });
      window.addEventListener('mousemove', s.onMove, { passive: true });
      if (on('jxDots')) s.buildDots();
    },

    teardown: function () {
      this.cancel();
      de.classList.remove('jx-snap', 'jx-snap-touch');
      de.style.removeProperty('--jx-header');
      sectionsOf().forEach(function (s) { s.removeAttribute('data-jx-snap-skip'); });
      if (this.onWheel) {
        window.removeEventListener('wheel', this.onWheel, { passive: false });
        window.removeEventListener('keydown', this.onKey);
        window.removeEventListener('mousedown', this.onDown, true);
        window.removeEventListener('scroll', this.onScroll, { passive: true });
        window.removeEventListener('mousemove', this.onMove, { passive: true });
        this.onWheel = null;
      }
      clearTimeout(this.sleepT);
      if (this.dots) {
        this.dots.parentNode.removeChild(this.dots);
        this.dots = null;
        this.dotBtns = [];
      }
      /* a rebuilt rail must be refilled */
      this.dotSig = '';
      this.dotHover = false;
      this.markPending = false;
      this.mode = '';
    },

    wheel: function (e) {
      if (e.defaultPrevented || e.ctrlKey || e.metaKey) return;
      var dy = e.deltaY * (e.deltaMode === 1 ? 32 : (e.deltaMode === 2 ? window.innerHeight : 1));
      if (!dy || Math.abs(e.deltaX) > Math.abs(dy)) return;
      if (overlayOpen() || canScrollInside(e.target, dy)) return;
      e.preventDefault();

      var t = now();
      var abs = Math.abs(dy);
      var gap = t - this.lastT;
      this.lastT = t;
      /* the first event after a pause is one detent of this wheel (zoom changes its size) */
      if (gap > 180) this.notchAbs = abs;
      /* while moving, swallow the gesture (and its inertia tail) */
      if (this.anim) {
        this.lastAbs = abs;
        this.peak = Math.max(this.peak, abs);
        this.armed = false;
        return;
      }
      /* a new push: a pause, a clear acceleration, or a fresh mouse-wheel notch. A notch
         never re-arms below the swallowed gesture's peak, so a decaying trackpad tail
         passing 50/100/150 cannot pose as one */
      var notch = e.deltaMode === 1 ||
        (abs >= 50 && Math.abs(abs / 50 - Math.round(abs / 50)) < 0.02) ||
        (abs >= 20 && gap >= 40 && Math.abs(abs - this.notchAbs) <= Math.max(1, this.notchAbs * 0.02));
      if (!this.armed && (gap > 180 || abs > this.lastAbs * 1.8 + 6 || (notch && abs >= this.peak && t - this.animEnd > 150))) {
        this.armed = true;
        this.accum = 0;
      }
      this.lastAbs = abs;
      this.peak = Math.max(this.peak, abs);
      if (!this.armed) return;
      this.accum += dy;
      if (Math.abs(this.accum) < 14) return;
      this.armed = false;
      this.accum = 0;
      this.peak = abs;
      this.step(dy > 0 ? 1 : -1);
    },

    key: function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var k = e.key;
      var dir = 0;
      if (k === 'ArrowDown' || k === 'PageDown' || (k === ' ' && !e.shiftKey)) dir = 1;
      else if (k === 'ArrowUp' || k === 'PageUp' || (k === ' ' && e.shiftKey)) dir = -1;
      else if (k === 'Home') dir = -2;
      else if (k === 'End') dir = 2;
      if (!dir) return;
      var t = e.target;
      if (t && t.nodeType === 1) {
        if (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT|OPTION|VIDEO|AUDIO|IFRAME)$/.test(t.tagName)) return;
        if (t.closest('[role="slider"],[role="listbox"],[role="menu"],[role="tablist"],[role="dialog"],[data-no-snap]')) return;
        if (k === ' ' && t.closest('a,button,summary,label,[role="button"]')) return;
      }
      if (overlayOpen()) return;
      e.preventDefault();
      if (this.anim) return;
      if (dir === 2) this.to(maxScroll());
      else if (dir === -2) this.to(0);
      else this.step(dir);
    },

    step: function (dir) {
      var y = scrollY();
      var pts = this.pts;
      var target = null;
      var i;
      if (dir > 0) {
        for (i = 0; i < pts.length; i++) if (pts[i].y > y + 4) { target = pts[i].y; break; }
      } else {
        for (i = pts.length - 1; i >= 0; i--) if (pts[i].y < y - 4) { target = pts[i].y; break; }
      }
      if (target === null) target = dir > 0 ? maxScroll() : 0;
      this.to(target);
    },

    to: function (y) {
      var s = this;
      var from = scrollY();
      y = Math.round(clamp(y, 0, maxScroll()));
      var dist = y - from;
      s.cancel();
      if (Math.abs(dist) < 2) return;
      if (d.hidden || reduced() || !window.requestAnimationFrame) {
        s.write(y);
        s.animEnd = now();
        return;
      }
      var dur = clamp(560 + Math.abs(dist) * 0.42, 820, 1250);
      var t0 = now();
      var a = s.anim = { raf: 0 };
      var tick = function (ts) {
        if (s.anim !== a) return;
        var p = clamp((ts - t0) / dur, 0, 1);
        var e = p < 0.5 ? 8 * p * p * p * p : 1 - Math.pow(-2 * p + 2, 4) / 2;
        s.write(from + dist * e);
        if (p < 1) a.raf = window.requestAnimationFrame(tick);
        else { s.anim = null; s.animEnd = now(); }
      };
      a.raf = window.requestAnimationFrame(tick);
    },

    write: function (y) {
      this.lastWritten = Math.round(y);
      try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
      catch (err) { window.scrollTo(0, y); }
    },

    cancel: function () {
      if (this.anim) {
        if (window.cancelAnimationFrame) window.cancelAnimationFrame(this.anim.raf);
        this.anim = null;
        this.animEnd = now();
      }
    },

    /* ---- dots ---- */
    buildDots: function () {
      var s = this;
      var nav = d.createElement('nav');
      nav.className = 'jx-dots';
      nav.setAttribute('aria-label', STR.sectionNav || 'Page sections');
      nav.addEventListener('mouseenter', function () { s.dotHover = true; clearTimeout(s.sleepT); });
      nav.addEventListener('mouseleave', function () { s.dotHover = false; s.sleepSoon(); });
      body.appendChild(nav);
      s.dots = nav;
      s.wake();
    },

    wake: function () {
      if (!this.dots) return;
      this.dots.classList.add('is-awake');
      this.sleepSoon();
    },

    sleepSoon: function () {
      var s = this;
      clearTimeout(s.sleepT);
      s.sleepT = setTimeout(function () {
        if (!s.dots) return;
        if (s.dotHover || s.dots.matches(':focus-within')) s.sleepSoon();
        else s.dots.classList.remove('is-awake');
      }, 2200);
    },

    syncDots: function () {
      var s = this;
      if (!s.dots) return;
      var sig = s.groups.map(function (g) { return g.label; }).join('|');
      if (sig !== s.dotSig) {
        s.dotSig = sig;
        s.dots.innerHTML = '';
        s.dotBtns = s.groups.map(function (g, i) {
          var b = d.createElement('button');
          var lab = d.createElement('span');
          b.type = 'button';
          b.className = 'jx-dot';
          b.setAttribute('aria-label', g.label);
          lab.className = 'jx-dot-label';
          lab.setAttribute('aria-hidden', 'true');
          lab.textContent = g.label;
          b.appendChild(lab);
          b.addEventListener('click', function () {
            var grp = s.groups[i];
            if (grp) s.to(grp.y);
          });
          s.dots.appendChild(b);
          return b;
        });
      }
      s.mark();
    },

    markSoon: function () {
      var s = this;
      if (!s.dots || s.markPending) return;
      s.markPending = true;
      frame(function () { s.markPending = false; s.mark(); });
    },

    mark: function () {
      if (!this.dots) return;
      var y = scrollY() + 8;
      var cur = 0;
      var gs = this.groups;
      for (var i = 0; i < gs.length; i++) if (gs[i].y <= y) cur = i;
      this.dotBtns.forEach(function (b, i) { b.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      /* dot colour follows the band under the dots */
      var mid = window.innerHeight / 2;
      var light = false;
      /* v7: bands are only light in light mode (where the hero is light too) */
      var lightMode = de.getAttribute('data-theme') === 'light';
      var list = sectionsOf();
      if (FOOTER) list.push(FOOTER);
      for (var k = 0; k < list.length; k++) {
        var r = list[k].getBoundingClientRect();
        if (r.top <= mid && r.bottom > mid) {
          var fc = list[k].firstElementChild;
          light = !!(lightMode && fc && fc.matches('.scheme-cream, .scheme-oat, .hero'));
          break;
        }
      }
      this.dots.classList.toggle('on-light', light);
    }
  };

  /* ------------------------------------------------------------------
     Hero product flight into the landing stage
     ------------------------------------------------------------------ */
  /* Where the product sits inside its transparent PNG, and how far it leans: the
     alpha silhouette gives the top/bottom margins, and the row centres of the lower
     body give the lean (the pump nozzle would skew a whole-shape axis). A tainted
     canvas (image on another origin, e.g. the theme editor) keeps the values
     measured on the Warm Nude hero PNG. The result describes the product stood
     upright: its height as a share of the PNG box, its body centre across (clear
     of the nozzle) and its centre down, all as fractions of the box. */
  function artOf(img) {
    var out = { share: 0.88, bodyCx: 0.543, midY: 0.493, tilt: -6.2 };
    try {
      var w = 64;
      var h = Math.max(16, Math.round(w * img.naturalHeight / img.naturalWidth));
      var cv = d.createElement('canvas');
      cv.width = w;
      cv.height = h;
      var g = cv.getContext('2d');
      g.drawImage(img, 0, 0, w, h);
      var px = g.getImageData(0, 0, w, h).data;
      var rows = [], x0 = w, x1 = -1, y0 = -1, y1 = -1, x, y;
      for (y = 0; y < h; y++) {
        var a = -1, b = -1;
        for (x = 0; x < w; x++) {
          if (px[(y * w + x) * 4 + 3] > 128) { if (a < 0) a = x; b = x; }
        }
        if (a < 0) continue;
        rows[y] = [a, b];
        if (a < x0) x0 = a;
        if (b > x1) x1 = b;
        if (y0 < 0) y0 = y;
        y1 = y;
      }
      if (y0 < 0 || y1 - y0 < 8) return out;
      var n = 0, sy = 0, sx = 0, syy = 0, sxy = 0;
      for (y = Math.round(y0 + (y1 - y0) * 0.38); y <= Math.round(y0 + (y1 - y0) * 0.97); y++) {
        if (!rows[y]) continue;
        var c = (rows[y][0] + rows[y][1] + 1) / 2;
        n++; sy += y; sx += c; syy += y * y; sxy += y * c;
      }
      var den = n * syy - sy * sy;
      var slope = den ? (n * sxy - sy * sx) / den : 0;
      var tilt = Math.atan(slope) * 180 / Math.PI;
      /* stand the silhouette upright the way CSS rotate(tilt) does (about the box
         centre, y down), then measure what gets matched against the photo */
      var t = tilt * Math.PI / 180, co = Math.cos(t), si = Math.sin(t);
      var pts = [], top = Infinity, bot = -Infinity;
      for (y = y0; y <= y1; y++) {
        for (x = 0; x < w; x++) {
          if (px[(y * w + x) * 4 + 3] <= 128) continue;
          var ddx = x + 0.5 - w / 2, ddy = y + 0.5 - h / 2;
          var uy = ddx * si + ddy * co + h / 2;
          pts.push(ddx * co - ddy * si + w / 2, uy);
          if (uy < top) top = uy;
          if (uy > bot) bot = uy;
        }
      }
      /* body centre across: middle of each 1px band over 55-90% of the upright height */
      var lo = top + (bot - top) * 0.55, hi = top + (bot - top) * 0.9, bands = {}, bsum = 0, bcnt = 0, k;
      for (var i = 0; i < pts.length; i += 2) {
        if (pts[i + 1] < lo || pts[i + 1] > hi) continue;
        k = Math.floor(pts[i + 1]);
        if (!bands[k]) bands[k] = [pts[i], pts[i]];
        else {
          if (pts[i] < bands[k][0]) bands[k][0] = pts[i];
          if (pts[i] > bands[k][1]) bands[k][1] = pts[i];
        }
      }
      for (k in bands) { bsum += (bands[k][0] + bands[k][1]) / 2; bcnt++; }
      if (!bcnt) return out;
      /* sample centres sit half a pixel inside the silhouette at each end */
      out = { share: (bot - top + 1) / h, bodyCx: bsum / bcnt / w, midY: (top + bot) / 2 / h, tilt: tilt };
    } catch (e) { /* tainted canvas: keep the measured defaults */ }
    return out;
  }

  var Flight = {
    state: '',

    init: function () {
      var self = this;
      if (!isHome) return;
      var stages = d.querySelectorAll('.iwt--stage');
      if (!stages.length) return;
      /* only the first stage receives the product; any others show their photo */
      for (var i = 1; i < stages.length; i++) stages[i].classList.remove('iwt--stage');
      var iwt = stages[0];
      var hero = d.querySelector('.hero--float');
      var src = hero && hero.querySelector('.hero-product');
      var slot = iwt.querySelector('[data-land-slot]');
      if (!src || !slot) { iwt.classList.remove('iwt--stage'); return; }

      self.iwt = iwt;
      self.hero = hero;
      self.src = src;
      self.slot = slot;
      self.fly = on('jxFlight') && !design && !reduced();
      /* landing style "photo": the product settles onto the bottle in the section photo */
      self.photo = iwt.classList.contains('iwt--photo-land');

      var begin = function () {
        var url = src.currentSrc || src.src;
        if (!url || self.landed) return;
        var img = self.landed = new Image();
        img.className = 'iwt-stage-product';
        img.alt = '';
        img.decoding = 'async';
        var ready = function () {
          if (self.landed !== img || iwt.classList.contains('is-staged') || !img.naturalWidth) return;
          /* the slot takes the product's proportions, so its box equals the image */
          slot.style.setProperty('--jx-ar', (img.naturalWidth / img.naturalHeight).toFixed(4));
          if (self.photo) self.art = artOf(img);
          iwt.classList.add('is-staged');
          self.measure();
          self.update();
        };
        img.addEventListener('load', ready);
        img.src = url;
        slot.appendChild(img);
        if (self.fly) {
          var f = self.flyer = d.createElement('div');
          /* no dark mode photo: the flyer takes on the dimmed photo's grade as it lands */
          f.className = 'jx-flyer' + (self.photo && iwt.classList.contains('iwt--no-dark-photo') ? ' jx-flyer--no-dark' : '');
          f.setAttribute('aria-hidden', 'true');
          var glow = d.createElement('span');
          glow.className = 'jx-flyer-glow';
          var fi = new Image();
          fi.alt = '';
          fi.decoding = 'async';
          fi.src = url;
          f.appendChild(glow);
          f.appendChild(fi);
          body.appendChild(f);
          self.onScroll = function () { self.schedule(); };
          window.addEventListener('scroll', self.onScroll, { passive: true });
        }
        if (img.complete && img.naturalWidth) ready();
      };
      /* the photo decides where the product lands, so re-aim once it has its size */
      if (self.photo) {
        self.onPicLoad = function () { if (self.iwt) { self.measure(); self.update(); } };
        [].forEach.call(iwt.querySelectorAll('.iwt-img'), function (im) {
          if (!im.complete) im.addEventListener('load', self.onPicLoad);
        });
      }
      if (src.complete && src.naturalWidth) begin();
      else {
        self.onSrcLoad = begin;
        src.addEventListener('load', begin);
      }
    },

    destroy: function () {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll, { passive: true });
      if (this.src && this.onSrcLoad) this.src.removeEventListener('load', this.onSrcLoad);
      if (this.flyer && this.flyer.parentNode) this.flyer.parentNode.removeChild(this.flyer);
      /* theme editor reloads: leave the stage exactly as rendered, so init starts clean */
      if (this.landed && this.landed.parentNode) this.landed.parentNode.removeChild(this.landed);
      clearTimeout(this.ringT);
      clearTimeout(this.revealT);
      if (this.hero) this.hero.classList.remove('jx-flying', 'jx-src-hidden');
      if (this.iwt) {
        var onPic = this.onPicLoad;
        if (onPic) [].forEach.call(this.iwt.querySelectorAll('.iwt-img'), function (im) { im.removeEventListener('load', onPic); });
        this.iwt.classList.remove('is-staged', 'is-landed', 'is-landing', 'is-revealed', 'is-quiet');
        this.iwt.style.removeProperty('--jx-land');
        this.iwt.style.removeProperty('--jx-scene');
      }
      if (this.slot) {
        this.slot.style.removeProperty('--jx-ar');
        this.slot.style.removeProperty('--slot-x');
        this.slot.style.removeProperty('--slot-y');
        this.slot.style.removeProperty('--slot-h');
      }
      this.onPicLoad = null;
      this.art = null;
      this.photo = false;
      this.onScroll = null;
      this.onSrcLoad = null;
      this.flyer = null;
      this.landed = null;
      this.iwt = null;
      this.slot = null;
      this.src = null;
      this.hero = null;
      this.cap = null;
      this.keepP = null;
      this.hold = false;
      this.atStage = false;
      this.warmed = false;
      this.waitPic = null;
      this.state = '';
    },

    measure: function () {
      var s = this;
      if (!s.iwt || !s.slot) return;
      if (s.photo) s.placeSlot();
      s.vw = window.innerWidth;
      var hh = headerH();
      var avail = window.innerHeight - hh;
      var sec = s.iwt.closest('.shopify-section') || s.iwt;
      var prev = sec.previousElementSibling;
      var start = (prev && prev.classList.contains('shopify-section') && prev.offsetHeight > 0 &&
        isShort(prev, avail)) ? prev : sec;
      s.y1 = Math.max(1, Math.min(maxScroll(), docTop(start) - hh));
      /* the trip covers the last ~80% screen of scroll before the stage, so a hero
         taller than the screen (phones) can be read before the product lifts off */
      var y0 = s.y1 - window.innerHeight * 0.8;
      /* single column (phones): the product scrolls away with the hero so its copy reads
         clear, then drops in from under the sticky header as the stage arrives */
      if (window.innerWidth < 990) {
        var copy = s.hero.querySelector('.hero-card');
        if (copy) y0 = Math.max(y0, docTop(copy) + copy.offsetHeight - window.innerHeight * 0.4);
      }
      s.y0 = Math.max(0, Math.min(y0, s.y1 - 80));
      var r = s.slot.getBoundingClientRect();
      var sy = scrollY();
      s.t = { cx: r.left + r.width / 2, cy: r.top + r.height / 2 + sy, w: r.width, h: r.height };
      var rot = parseFloat(getComputedStyle(s.iwt).getPropertyValue('--land-rot'));
      s.rot1 = isNaN(rot) ? -8 : rot;
      /* a refresh mid-flight re-reads the poses but keeps the progress baseline */
      s.keepP = (s.state === 'fly' && s.cap) ? s.cap.p : null;
      s.cap = null;
    },

    /* photo landing: put the slot over the bottle in the photo that is showing. The
       section prints the bottle's centre and height as % of the image (one set for
       the image, one for the dark mode image); the photo is object-fit:cover, so
       the crop and object-position are replayed here. The slot box is the PNG box,
       so its height is the bottle height divided by the product's share of the PNG
       once stood upright. */
    placeSlot: function () {
      var s = this;
      var media = s.slot.closest('.iwt-media') || s.iwt;
      /* forget an earlier crop shift, so the section's own object-position is read */
      [].forEach.call(media.querySelectorAll('.iwt-img'), function (im) { im.style.objectPosition = ''; });
      var pic = s.pic();
      var alt = !!(pic && pic.classList.contains('jx-img-dark'));
      var cs = getComputedStyle(s.iwt);
      var num = function (name, fb) {
        var v = parseFloat(cs.getPropertyValue(name));
        return isNaN(v) ? fb : v / 100;
      };
      var bx = num(alt ? '--land-x-dark' : '--land-x', 0.5);
      var by = num(alt ? '--land-y-dark' : '--land-y', 0.45);
      var bh = num(alt ? '--land-h-dark' : '--land-h', 0.6);
      var mw = media.clientWidth, mh = media.clientHeight;
      if (!mw || !mh) return;
      var iw = (pic && (pic.naturalWidth || parseFloat(pic.getAttribute('width')))) || mw;
      var ih = (pic && (pic.naturalHeight || parseFloat(pic.getAttribute('height')))) || mh;
      var k = Math.max(mw / iw, mh / ih);
      var rw = iw * k, rh = ih * k;
      var pos = (pic ? getComputedStyle(pic).objectPosition : '').split(' ');
      var fx = parseFloat(pos[0]) / 100, fy = parseFloat(pos[1]) / 100;
      if (isNaN(fx)) fx = 0.5;
      if (isNaN(fy)) fy = 0.5;
      var art = s.art || { share: 0.88, bodyCx: 0.543, midY: 0.493, tilt: -6.2 };
      var boxH = bh * rh / Math.max(0.3, art.share);
      var ar = parseFloat(s.slot.style.getPropertyValue('--jx-ar')) || 0.415;
      /* very wide panels crop the photo top and bottom: slide the crop so the
         whole bottle stays inside the panel (the slot clips at the panel edge) */
      var oy = (mh - rh) * fy;
      if (rh > mh + 1) {
        var margin = Math.min(24, mh * 0.04);
        var bTop = oy + (by - bh / 2) * rh, bBot = oy + (by + bh / 2) * rh;
        var want = oy;
        if (bTop < margin) want = oy + (margin - bTop);
        else if (bBot > mh - margin) want = oy - (bBot - (mh - margin));
        if (want !== oy) {
          oy = Math.min(0, Math.max(mh - rh, want));
          fy = oy / (mh - rh);
          var op = (fx * 100).toFixed(2) + '% ' + (fy * 100).toFixed(2) + '%';
          [].forEach.call(media.querySelectorAll('.iwt-img'), function (im) { im.style.objectPosition = op; });
        }
      }
      var cx = (mw - rw) * fx + bx * rw - (art.bodyCx - 0.5) * boxH * ar;
      var cy = oy + by * rh - (art.midY - 0.5) * boxH;
      s.slot.style.setProperty('--slot-x', cx.toFixed(1) + 'px');
      s.slot.style.setProperty('--slot-y', cy.toFixed(1) + 'px');
      s.slot.style.setProperty('--slot-h', boxH.toFixed(1) + 'px');
      /* stand the product upright, like the bottle in the photo */
      s.iwt.style.setProperty('--land-rot', (art.tilt || 0).toFixed(2) + 'deg');
    },

    /* the section photo that is showing in the current colour mode */
    pic: function () {
      var media = this.slot && (this.slot.closest('.iwt-media') || this.iwt);
      var found = null;
      if (!media) return null;
      [].forEach.call(media.querySelectorAll('.iwt-img'), function (im) {
        if (!found && getComputedStyle(im).display !== 'none') found = im;
      });
      return found;
    },

    /* hand over from the product to the photo, but only once the photo has pixels:
       otherwise the product would fade out onto an empty panel */
    reveal: function () {
      var s = this;
      if (!s.iwt || s.state !== 'land') return;
      var pic = s.pic();
      if (pic && !(pic.complete && pic.naturalWidth)) {
        s.iwt.classList.remove('is-revealed');
        if (s.waitPic !== pic) {
          s.waitPic = pic;
          var again = function () {
            pic.removeEventListener('load', again);
            if (s.waitPic === pic) s.waitPic = null;
            s.reveal();
          };
          pic.addEventListener('load', again);
        }
        return;
      }
      s.iwt.classList.add('is-revealed');
      s.warm();
    },

    /* after the first landing, fetch the other colour mode's photo too, so a
       switch while landed has it ready */
    warm: function () {
      var s = this;
      if (s.warmed || !s.iwt) return;
      s.warmed = true;
      [].forEach.call(s.iwt.querySelectorAll('.iwt-img'), function (im) {
        if (!(im.complete && im.naturalWidth)) im.loading = 'eager';
      });
    },

    /* a resize or rotation while landed: move the scroll to the stage's new
       position instead of letting the product take off from the new layout */
    stay: function () {
      var s = this;
      s.hold = false;
      if (s.state !== 'land' || !s.iwt || !s.fly || !Snap.mode) return;
      var y = Math.round(s.y1);
      if (Math.abs(scrollY() - y) <= 1.5) return;
      if (Snap.mode === 'js') { Snap.cancel(); Snap.write(y); Snap.markSoon(); }
      else {
        try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
        catch (err) { window.scrollTo(0, y); }
      }
    },

    /* read the hero product's pose right now, with its float motion paused */
    capture: function () {
      var s = this;
      s.hero.classList.add('jx-flying');
      var fl = s.hero.querySelector('.hero-float');
      var ang = 0;
      if (fl) {
        var m = /matrix\(([^)]+)\)/.exec(getComputedStyle(fl).transform || '');
        if (m) {
          var v = m[1].split(',').map(parseFloat);
          ang = Math.atan2(v[1], v[0]) * 180 / Math.PI;
        }
      }
      var w = s.src.offsetWidth;
      var h = s.src.offsetHeight;
      if (!w || !h || !s.t || !s.t.h) return false;
      var r = s.src.getBoundingClientRect();
      var y = scrollY();
      /* progress at lift-off keeps a take-off from the resting hero seamless; a re-measure
         mid-flight keeps that baseline; coming back from the stage (or a load part-way
         down) the path depends on scroll alone, so reversing retraces it */
      var p0 = 0;
      if (s.state === 'rest') p0 = clamp((y - s.y0) / Math.max(1, s.y1 - s.y0), 0, 0.98);
      else if (s.state === 'fly' && s.keepP != null) p0 = s.keepP;
      s.cap = { cx: r.left + r.width / 2, cy: r.top + r.height / 2 + y, w: w, h: h, rot: ang, p: p0 };
      s.keepP = null;
      s.flyer.style.width = w + 'px';
      s.flyer.style.height = h + 'px';
      return true;
    },

    schedule: function () {
      var s = this;
      if (s.pending) return;
      s.pending = true;
      frame(function () { s.pending = false; s.update(); });
    },

    update: function () {
      var s = this;
      if (!s.iwt || !s.iwt.classList.contains('is-staged')) return;
      /* without section stepping (free wheel scroll, e.g. a narrow desktop window) the
         product could stop mid-air, so it waits on the stage instead */
      if (!s.fly || !s.flyer || !Snap.mode) { s.atStage = false; s.land(true); return; }
      var y = scrollY();
      /* resized or rotated while landed: stay on the stage until refresh() re-aims */
      if (s.state === 'land' && y < s.y1 - 1.5 && (s.hold || window.innerWidth !== s.vw)) return;
      /* resting on the stage itself: only then does a resize bring the stage back into view */
      s.atStage = Math.abs(y - s.y1) <= 2;
      /* snap stops are whole pixels while y1 can be fractional: allow 1.5px */
      if (y >= s.y1 - 1.5) { s.land(false); return; }
      var p = clamp((y - s.y0) / Math.max(1, s.y1 - s.y0), 0, 1);
      if (p <= 0) { s.rest(); return; }
      if (!s.cap && !s.capture()) return;

      var c = s.cap;
      var t = s.t;
      /* q runs 0..1 from the pose captured at lift-off, so the hand-off never jumps */
      var q = clamp((p - c.p) / (1 - c.p), 0, 1);
      var e = q < 0.5 ? 4 * q * q * q : 1 - Math.pow(-2 * q + 2, 3) / 2;
      var k = 1 + (t.h / c.h - 1) * e;
      var cx = c.cx + (t.cx - c.cx) * e;
      /* vertical travel follows the page 1:1, so the product seems to hover
         while the next section slides up under it; a soft arc lifts it */
      var arc = window.innerWidth < 990 ? 0 : Math.sin(Math.PI * q) * Math.min(70, window.innerHeight * 0.08);
      var cy = c.cy + (t.cy - c.cy) * q - y - arc;
      var rot = c.rot + (s.rot1 - c.rot) * e;
      s.flyer.style.transform = 'translate3d(' + (cx - c.w / 2).toFixed(1) + 'px,' + (cy - c.h / 2).toFixed(1) +
        'px,0) rotate(' + rot.toFixed(2) + 'deg) scale(' + k.toFixed(4) + ')';
      s.flyer.style.setProperty('--jx-glow', Math.sin(Math.PI * q).toFixed(3));
      s.iwt.style.setProperty('--jx-land', e.toFixed(3));
      /* photo landing: the scene gathers softly behind the last half of the trip (the whole
         trip on phones, where the short drop-in starts with the stage already on screen) */
      if (s.photo) {
        var sc = clamp(window.innerWidth < 990 ? q : (q - 0.5) / 0.5, 0, 1);
        sc = (sc * sc * (3 - 2 * sc)).toFixed(3);
        s.iwt.style.setProperty('--jx-scene', sc);
        s.flyer.style.setProperty('--jx-scene', sc);
      }
      if (s.state !== 'fly') {
        s.state = 'fly';
        s.flyer.classList.add('is-on');
        s.hero.classList.add('jx-src-hidden');
        s.iwt.classList.remove('is-landed', 'is-landing', 'is-revealed', 'is-quiet');
        clearTimeout(s.revealT);
      }
    },

    rest: function () {
      var s = this;
      if (s.state === 'rest') return;
      s.state = 'rest';
      if (s.flyer) s.flyer.classList.remove('is-on');
      s.hero.classList.remove('jx-src-hidden', 'jx-flying');
      s.iwt.classList.remove('is-landed', 'is-landing', 'is-revealed', 'is-quiet');
      s.iwt.style.setProperty('--jx-land', '0');
      s.iwt.style.setProperty('--jx-scene', '0');
      clearTimeout(s.revealT);
      s.cap = null;
    },

    land: function (quiet) {
      var s = this;
      if (s.state === 'land') return;
      var wasFlying = s.state === 'fly';
      s.state = 'land';
      if (s.flyer) s.flyer.classList.remove('is-on');
      if (s.hero) s.hero.classList.remove('jx-src-hidden', 'jx-flying');
      s.iwt.classList.add('is-landed');
      s.iwt.style.setProperty('--jx-land', '1');
      s.cap = null;
      /* photo landing: the product on the bottle hands over to the photo */
      if (s.photo) {
        s.iwt.style.setProperty('--jx-scene', '1');
        clearTimeout(s.revealT);
        if (quiet) {
          s.iwt.classList.add('is-quiet');
          s.reveal();
        } else {
          s.iwt.classList.remove('is-quiet');
          s.revealT = setTimeout(function () { s.reveal(); }, 60);
        }
      }
      if (wasFlying && !quiet) {
        s.iwt.classList.remove('is-landing');
        void s.iwt.offsetWidth;
        s.iwt.classList.add('is-landing');
        clearTimeout(s.ringT);
        s.ringT = setTimeout(function () { if (s.iwt) s.iwt.classList.remove('is-landing'); }, 1300);
      }
    }
  };

  /* ------------------------------------------------------------------
     Reveal on enter
     ------------------------------------------------------------------ */
  var Reveal = {
    init: function () {
      if (!on('jxReveal') || design || reduced() || !MAIN || !('IntersectionObserver' in window)) return;
      var vh = window.innerHeight;
      var items = [];
      var qa = function (sel) { return [].slice.call(MAIN.querySelectorAll(sel)); };
      var tag = function (el, kind, delay) {
        if (!el || el.nodeType !== 1 || el.hasAttribute('data-jxr') || el.closest('.hero, [data-jxr]')) return;
        var r = el.getBoundingClientRect();
        if (r.height === 0 || r.bottom <= 0 || r.top < vh * 0.95) return;
        el.setAttribute('data-jxr', kind || '');
        if (delay) el.style.setProperty('--jx-d', delay + 'ms');
        items.push(el);
      };
      var mask = function (h) {
        if (!h || h.querySelector('.jx-mask')) return;
        var outer = d.createElement('span');
        var inner = d.createElement('span');
        outer.className = 'jx-mask';
        inner.className = 'jx-mask-in';
        while (h.firstChild) inner.appendChild(h.firstChild);
        outer.appendChild(inner);
        h.appendChild(outer);
      };

      de.classList.add('jx-reveal-on');
      qa('.center-head').forEach(function (el) { tag(el, 'head'); });
      qa('.iwt-copy-in').forEach(function (box) {
        [].forEach.call(box.children, function (c, i) { tag(c, c.matches('h2') ? 'head' : '', 90 * i); });
      });
      qa('.product-grid, .col-grid3, .collection-list-grid, .blog-grid, .ki-grid').forEach(function (grid) {
        var first = grid.firstElementChild;
        var cols = Math.max(1, Math.round(grid.clientWidth / ((first && first.offsetWidth) || grid.clientWidth)));
        [].forEach.call(grid.children, function (c, i) {
          tag(c, 'card', (i % cols) * 90 + Math.floor(i / cols) * 60);
        });
      });
      qa('.mc-grid, .faq').forEach(function (list) {
        [].forEach.call(list.children, function (c, i) { tag(c, '', 70 * i); });
      });
      qa('.fc-actions, .newsletter-in').forEach(function (el) { tag(el, ''); });

      items.forEach(function (el) {
        if (el.getAttribute('data-jxr') !== 'head') return;
        mask(el.matches('h1, h2') ? el : el.querySelector('h1, h2'));
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          io.unobserve(el);
          el.classList.add('is-in');
          var delay = parseFloat(el.style.getPropertyValue('--jx-d')) || 0;
          /* hand the element back to its own hover transitions */
          setTimeout(function () {
            el.removeAttribute('data-jxr');
            el.classList.remove('is-in');
            el.style.removeProperty('--jx-d');
          }, 1700 + delay);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
      items.forEach(function (el) { io.observe(el); });
    }
  };

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  var rt = 0;
  function refresh() {
    var keep = Flight.state === 'land' && Flight.hold;
    Snap.apply();
    Flight.measure();
    if (keep) Flight.stay();
    Flight.update();
  }
  function soon() {
    clearTimeout(rt);
    rt = setTimeout(refresh, 160);
  }

  Snap.apply();
  Flight.init();
  Reveal.init();

  window.addEventListener('resize', soon);
  window.addEventListener('load', soon);
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(soon);
  if (window.ResizeObserver && MAIN) new ResizeObserver(soon).observe(MAIN);
  listenMq(mqFine, soon);
  listenMq(mqReduce, function () {
    Flight.fly = on('jxFlight') && !design && !reduced();
    if (!Flight.fly && Flight.iwt) Flight.land(true);
    soon();
  });
  d.addEventListener('shopify:section:load', function () {
    Flight.destroy();
    Flight.init();
    soon();
  });
  /* rotation or URL-bar resize mid-flight: re-aim now, not after the debounce. Resting on
     the stage (and not mid-swipe), a resize keeps the stage in view; anywhere else on the
     page the visitor stays where they are */
  var touching = false;
  window.addEventListener('resize', function () {
    if (Flight.state === 'fly') { Flight.measure(); Flight.update(); }
    else if (Flight.state === 'land' && Flight.atStage && !touching) Flight.hold = true;
  });
  /* the visitor scrolling (not a layout change) is free to leave the stage */
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
    window.addEventListener(type, function () { Flight.hold = false; }, { passive: true, capture: true });
  });
  ['touchstart', 'touchend', 'touchcancel'].forEach(function (type) {
    window.addEventListener(type, function (e) { touching = !!(e.touches && e.touches.length); }, { passive: true, capture: true });
  });
  /* v7 colour modes: the dots follow the band colours of the new mode */
  d.addEventListener('joiex:themechange', function () {
    Snap.markSoon();
    /* the other mode may show the dark mode image, with its own bottle position */
    if (Flight.photo) {
      soon();
      if (Flight.state === 'land') Flight.reveal();
    }
  });

  window.JXMotion = { snap: Snap, flight: Flight, refresh: refresh };
})();
